// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { N20 } from '@atlaskit/theme/colors';
import { getIconSize } from './utils';
import { token } from '@atlaskit/tokens';
import { type Size } from '@atlaskit/icon';
interface TemplateIconProps {
	backgroundColor?: string;
	size: Size;
}

// we can't just use Avatar since that takes an icon URL
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const TemplateIcon = styled.div<TemplateIconProps>((props) => ({
	boxSizing: 'border-box',
	alignSelf: 'flex-start',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minHeight: `${getIconSize(props.size)}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	minWidth: `${getIconSize(props.size)}px`,
	borderRadius: '4px',
	textAlign: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundColor: props.backgroundColor
		? props.backgroundColor
		: token('color.background.neutral.bold', N20),
	border: `1px solid ${token('color.border', 'rgba(0, 0, 0, 0.1)')}`,
}));
